/// <amd-module name="Build/Admin/Common/Actions/AgentCloudActions" />
import { Action } from "VSS/Reflux/Action";

import { TaskAgentCloud } from "DistributedTask/Client/Contracts/TaskAgent";

export class AgentCloudActions {
    public agentCloudsUpdated = new Action<TaskAgentCloud[]>();
    public agentCloudAdded = new Action<TaskAgentCloud>();
    public agentCloudDeleted = new Action<TaskAgentCloud>();
}
